export default __webpack_public_path__ + "static/media/eat-scale@3x.ff960264.png";